import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { useCopilotAction, useCopilotReadable, useCopilotAdditionalInstructions } from "@copilotkit/react-core";
import constants from "../../../../utils/constants";
import Store from "../../../../utils/Store";
import { useStoreState } from "pullstate";
import { MIXPANEL_EVENTS } from "../../../../utils/mixpanelEvents";
import { trackEvent } from "../../../../utils/mixpanel";
import { get } from "lodash";
import { useRouter } from "next/router";
import { useAuth } from "@qure/qure-auth";
var useChangeThemeWithAI = function useChangeThemeWithAI(isAIAssistantEnabled) {
  var router = useRouter();
  var _useStoreState = useStoreState(Store, function (store) {
      return {
        isDarkMode: store.isDarkMode
      };
    }),
    isDarkMode = _useStoreState.isDarkMode;
  var THEME_OPTIONS = ["light", "dark"];
  var isViewerPage = router.pathname.includes("/viewer");
  useCopilotReadable({
    description: "The current theme",
    value: isDarkMode ? "dark" : "light",
    available: isAIAssistantEnabled ? "enabled" : "disabled"
  });
  var onToggleThemeClick = function onToggleThemeClick(_isDarkMode) {
    if (window) {
      localStorage.setItem(constants.PERSISTED.isDarkMode, String(!isDarkMode));
      Store.update(function (s) {
        s.isDarkMode = _isDarkMode;
      });
      trackEvent(MIXPANEL_EVENTS.THEME_CHANGED, {
        isDarkMode: _isDarkMode
      });
    }
  };
  useCopilotAdditionalInstructions({
    instructions: "\n      The 'changeTheme' action is used to change or toggle app theme when user specifies to change theme or mode, not any other property.\n      Do not change the theme if user asks to go back to worklist or any other page.\n      ",
    available: isAIAssistantEnabled ? "enabled" : "disabled"
  });
  useCopilotAction({
    name: "editReport1",
    available: isAIAssistantEnabled && !isViewerPage ? "enabled" : "disabled",
    description: "This action handles report editing requests. First check the patient context for the modality property.\n      If modality is null or undefined, it means no scans are uploaded - inform the user that scans must be uploaded before editing the report.\n      If modality has a value, inform the user they need to navigate to the viewer page and open the relevant series to edit the report.\n      Report editing is only available from the viewer page.",
    parameters: [],
    handler: function () {
      var _handler = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              return _context.a(2, "Please navigate to the viewer page first to edit the report. Report editing is only available in the viewer.");
          }
        }, _callee);
      }));
      function handler() {
        return _handler.apply(this, arguments);
      }
      return handler;
    }()
  });
  1;
  useCopilotAction({
    name: "changeTheme",
    available: isAIAssistantEnabled ? "enabled" : "disabled",
    description: "Use this action when user wants to change or toggle app theme.\n      If user specifies theme name, switch it to the specified theme or else switch it to the theme other than current theme.\n      If user specifies theme name same as current theme, ask user if they want to switch to other theme.\n      ",
    parameters: [{
      type: "string",
      name: "theme",
      "enum": THEME_OPTIONS,
      required: true,
      description: "Toggle or switch between light and dark theme if user does not specify the theme."
    }],
    handler: function () {
      var _handler2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref) {
        var theme, _isDarkMode;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              theme = _ref.theme;
              _isDarkMode = theme === "dark";
              trackEvent(MIXPANEL_EVENTS.ASSISTANT_ACTION, {
                action: "changeTheme",
                isDarkMode: _isDarkMode
              });
              onToggleThemeClick(_isDarkMode);
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      function handler(_x) {
        return _handler2.apply(this, arguments);
      }
      return handler;
    }()
  });
};
var useChangeTheme = function useChangeTheme() {
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var isAIAssistantEnabled = get(userInfo, ["settings", "ui_settings", "ai_assistant"], false);
  return useChangeThemeWithAI(isAIAssistantEnabled);
};
export default useChangeTheme;